import { Component } from "react";
import TitleBar from "../../components/ui/TitleBar";
import Select from "../../components/ui/Select";
import Radio from "../../components/ui/Radio";
import RectButton from "../../components/ui/button/RectButton";
import EditButton from "../../components/ui/button/EditButton";
import DeleteButton from "../../components/ui/button/DeleteButton";

import UsaStamp from '../../components/assets/images/usa-stamp.png';

import "./style.scss";
import { Link, withRouter } from "react-router-dom";
import Calendar from "../../components/ui/Calendar";
import Book from "../../components/Book";
import InputFile from "../../components/ui/InputFile";
import SwitchButton from "../../components/ui/button/SwitchButton";
import SavePopup from "../../components/Popup/SavePopup";
import AppContext from "../../contexts/AppContext";
import UseTemplatePopup from "../../components/Popup/UseTemplatePopup";
import EditAddressPopup from "../../components/Popup/EditAddressPopup";
import Option from "../../components/ui/Select/Option";
import CheckBox from "../../components/ui/CheckBox";

import BizCard from "../../components/assets/images/custom/biz-card.png"
import Amazon from "../../components/assets/images/gift/amazon.png"
import Cheesecake from "../../components/assets/images/gift/cheesecake.png"
import Handwrytten from "../../components/assets/images/gift/handwrytten.png"
import HappyDining from "../../components/assets/images/gift/happy-dining.png"
import HappyMoments from "../../components/assets/images/gift/happy-moments.png"
import Homedepot from "../../components/assets/images/gift/homedepot.png"
import MacMagianos from "../../components/assets/images/gift/mac-magianos.png"
import Starbucks from "../../components/assets/images/gift/starbucks.png"
import TargetGC from "../../components/assets/images/gift/target-gc.png"
import Visa from "../../components/assets/images/gift/visa.png"

class AddMessage extends Component {
    static contextType = AppContext;

    state = {
        showShippingMethod: false,
        writingStyle: null,
        maximumFontSize: false,
        message: "",
        characters: 0,
        mergeFields: null,
        signature: null,
        name: null,
        customInsert: 0,
        giftCard: 0,
        lastFocus: 0,
        signPos: 0
    }

    constructor(props) {
        super(props)
        this.customInserts = {
            1: { name: "Biz Card", src: BizCard }
        }

        this.gifts = {
            1: { name: "Amazom", src: Amazon, prices: [1, 2, 3, 4] },
            2: { name: "Cheesecake", src: Cheesecake, prices: [1, 2, 3, 4] },
            3: { name: "Handwrytten", src: Handwrytten, prices: [1, 2, 3, 4] },
            4: { name: "Happy Dining", src: HappyDining, prices: [1, 2, 3, 4] },
            5: { name: "Happy Moments", src: HappyMoments, prices: [1, 2, 3, 4] },
            6: { name: "Homedepot", src: Homedepot, prices: [1, 2, 3, 4] },
            7: { name: "Mac Magianos", src: MacMagianos, prices: [1, 2, 3, 4] },
            8: { name: "Starbucks", src: Starbucks, prices: [1, 2, 3, 4] },
            9: { name: "Target GC", src: TargetGC, prices: [1, 2, 3, 4] },
            10: { name: "Visa", src: Visa, prices: [1, 2, 3, 4] },
        }
    }

    shippingChanged = (e) => {
        this.setState({ showShippingMethod: true/*this.stampReadyMail.input.checked*/ });
    }

    writingStyleHandler = (e) => {
        this.setState({ writingStyle: e.currentTarget.value })
    }

    onMessageInputHandler = (e) => {
        let message = e.target.innerHTML;
        this.setState({ message: message, characters: message.length })
    }

    onSignatureInputHandler = (e) => {
        let name = e.target.innerHTML;
        this.setState({ name: name })
    }

    onKeyDownHandler = (e) => {
        if (this.state.characters >= 500 && e.keyCode !== 8) e.preventDefault();
    }

    render() {
        let completeOrder = this.props.match.params[0];

        return (
            <>
                <div className="full-container add-message">
                    <section className="section-box card-selected">
                        <TitleBar title={this.props.bulk ? "Bulk Upload" : "Card Selected"} />
                        <div className="box">
                            <div className="row lock">
                                <div className="image-card">
                                    <img src="https://via.placeholder.com/91x118" alt="Card Selected" />
                                </div>
                                <div className="table">
                                    <h3>Gold Congratulations</h3>
                                    <div className="row">
                                        <span className="title">Quantity</span>
                                        <span>50+</span>
                                        <span>100+</span>
                                        <span>500+</span>
                                        <span>1000+</span>
                                    </div>
                                    <div className="row">
                                        <span className="title">Price</span>
                                        <span className="highlight">$2.93</span>
                                        <span className="highlight">$2.76</span>
                                        <span className="highlight">$2.60</span>
                                        <span className="highlight">$2.44</span>
                                    </div>
                                </div>
                                {completeOrder ?
                                    <>
                                        <div className="break"></div>
                                        <Link className="edit-message-bt" to="/add-message"><RectButton text="EDIT MESSAGE" /></Link>
                                    </>
                                    : <div className="space"></div>}
                            </div>
                        </div>
                    </section>

                    <section className="section-box row">
                        <section className="section-box column">
                            {
                                !completeOrder && !this.props.bulk ?
                                    <section className="your-message">
                                        <TitleBar title="Your Message" />
                                        <div className="box">
                                            <p>Add Optional tags below to personalize your message:</p>
                                            <div className="row">
                                                <Select onChange={(e) => { this.setState({ mergeFields: `{{${e.target.value}}}` }) }}>
                                                    <Option hidden={true}>Add Merge Fields</Option>
                                                    <Option value="First Name">First Name</Option>
                                                    <Option value="Last Name">Last Name</Option>
                                                    <Option value="Business Name 1">Business Name 1</Option>
                                                    <Option value="Business Name 2">Business Name 2</Option>
                                                    <Option value="Business Name 3">Business Name 3</Option>
                                                    <Option value="Business Name 4">Business Name 4</Option>
                                                    <Option value="Business Name 5">Business Name 5</Option>
                                                    <Option value="Business Name 6">Business Name 6</Option>
                                                    <Option value="Business Name 7">Business Name 7</Option>
                                                    <Option value="Business Name 8">Business Name 8</Option>
                                                    <Option value="Business Name 9">Business Name 9</Option>
                                                </Select>
                                                <Select onChange={(e) => { this.setState({ signature: e.target.value, signPos: this.state.lastFocus }) }}>
                                                    <Option hidden={true}>Insert Signature</Option>
                                                    <Option value="https://via.placeholder.com/213x70/004AAB" label="Signature 1"><img src="https://via.placeholder.com/213x70/004AAB" alt="Signature" /></Option>
                                                    <Option value="https://via.placeholder.com/213x70/FFFF00" label="Signature 2"><img src="https://via.placeholder.com/213x70/FFFF00" alt="Signature" /></Option>
                                                    <Option value="https://via.placeholder.com/213x70/00FF00" label="Signature 3"><img src="https://via.placeholder.com/213x70/00FF00" alt="Signature" /></Option>
                                                    <Option value="https://via.placeholder.com/213x70/00FFFF" label="Signature 4"><img src="https://via.placeholder.com/213x70/00FFFF" alt="Signature" /></Option>
                                                    <Option value="https://via.placeholder.com/213x70/FF00FF" label="Signature 5"><img src="https://via.placeholder.com/213x70/FF00FF" alt="Signature" /></Option>
                                                </Select>
                                            </div>
                                            <div className="letter edit">
                                                <div className="message dashed-box">
                                                    <span onClick={() => this.inputMessage.focus()}>
                                                        {this.state.mergeFields ? <span className="title">{this.state.mergeFields}&nbsp;</span> : null}
                                                        {this.state.message ? null : <span className="place-holder">Wryte your message here...</span>}
                                                        <span ref={(t) => this.inputMessage = t} contentEditable="true" suppressContentEditableWarning={true} onInput={this.onMessageInputHandler} onKeyDown={this.onKeyDownHandler} onFocus={() => this.setState({ lastFocus: 0 })}></span>
                                                        {
                                                            this.state.signature && !this.state.signPos ? <span className="name">{"{{David signature}}"}</span> : null
                                                        }
                                                    </span>
                                                    <div className="characters">{this.state.characters} / 500 Characters</div>
                                                </div>
                                                <div className="signature dashed-box">
                                                    <div className="input">
                                                        <span className="place-holder" style={{position:this.state.name ? "" : "relative"}}>{this.state.name ? null : <>Optional Sign Off Here, <br />Name or Signature</>}</span>
                                                        <span className="editable" style={{position:this.state.name ? "" : "absolute"}} contentEditable="true" suppressContentEditableWarning={true} onInput={this.onSignatureInputHandler} onFocus={() => this.setState({ lastFocus: 1 })}></span>
                                                    </div>
                                                    {
                                                        this.state.signature && this.state.signPos ? <div className="name">{"{{David signature}}"}</div> : null
                                                    }
                                                </div>
                                            </div>
                                            <div className="actions">
                                                <div className="uh" onClick={() => this.context.setPopup(<UseTemplatePopup />)}>Use Template</div>
                                                <div className="uh" onClick={() => this.context.setPopup(<SavePopup />)}>Save as Template</div>
                                            </div>
                                        </div>
                                    </section>
                                    :
                                    <>
                                        <section className="request-date">
                                            <TitleBar title="Requested Send Date" />
                                            <div className="box">
                                                <Calendar />
                                                <div className="note">*Larger orders require additional time. For an estimate, please contact support.</div>
                                            </div>
                                        </section>

                                        {
                                            this.props.bulk ?
                                                <section className="upload-notes">
                                                    <TitleBar title="Upload Your Notes" />
                                                    <div className="box">
                                                        <div className="column">
                                                            <InputFile />
                                                            <p className="desc">Based on the selected card, each message must not be longer than 500 characters long. Each card must have all fields filled out.</p>
                                                            <div className="row download">
                                                                <a className="uh" href="http://www.google.com" target="_blank" rel="noreferrer">Download a Template</a>
                                                                <div className="switch row lock">
                                                                    <SwitchButton clean={true} />
                                                                    <p>Add new recipients to address book</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                                :
                                                <section className="return-address">
                                                    <TitleBar title="Return Address (your info)" />
                                                    <div className="box">
                                                        <div className="column">
                                                            <div className="row lock">
                                                                <div className="address">
                                                                    <span className="strong">Griflan Design </span>
                                                                    <span>4206 Spruce</span>
                                                                    <span>StreetPhiladelphia, PA, 19104</span>
                                                                </div>
                                                                <div className="stamp">
                                                                    <img src={UsaStamp} alt="Stamp" />
                                                                </div>
                                                            </div>
                                                            {/* <Link className="edit-bt" to="/my-address"><RectButton text="EDIT" onClick={() => this.context.setPopup(<EditAddressPopup />)} /></Link> */}
                                                            <RectButton className="edit-bt" text="EDIT" onClick={() => this.context.setPopup(<EditAddressPopup />)} />
                                                        </div>
                                                    </div>
                                                </section>
                                        }
                                    </>
                            }
                        </section>

                        {
                            completeOrder ?
                                <section className="recipients">
                                    <TitleBar title="Recipients" />
                                    <Book className="box">
                                        {{ name: "Ari Kaplan", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 2", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 3", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 4", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 5", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 6", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 7", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 8", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 9", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 10", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 11", address: "Philadelphia, PA, 19104" }}
                                        {{ name: "Ari Kaplan 12", address: "Philadelphia, PA, 19104" }}
                                    </Book>
                                </section>
                                :
                                <section className="preview">
                                    <TitleBar title={this.props.bulk ? "Choose Writing Style" : "Preview"} />
                                    <div className="box">
                                        {this.props.bulk ? null : <p>Choose writing style:</p>}
                                        <div className="row">
                                            <Select className={`writing-select ${this.state.writingStyle ? `${this.state.writingStyle} selected` : ""}`} onChange={this.writingStyleHandler}>
                                                <Option hidden={true}>Choose writing style</Option>
                                                {
                                                    this.context.fonts.map((item, i) => {
                                                        return <Option className={item.className} value={item.className} key={`font-opt-${i}`}>{item.name}</Option>
                                                    })
                                                }
                                            </Select>
                                            {this.props.bulk ? null : <CheckBox label="Maximum Font Size" onChange={(e) => this.setState({ maximumFontSize: e.target.checked })} />}
                                        </div>
                                        <div className={`letter dashed-box ${this.state.maximumFontSize ? "maximum" : ""} ${this.state.writingStyle ? this.state.writingStyle : ""}`}>
                                            <div className="message">
                                                <span>
                                                    {this.state.mergeFields ? <span className="title">{this.state.mergeFields}&nbsp;</span> : null}
                                                    <span dangerouslySetInnerHTML={{ __html: this.state.message }} />
                                                </span>
                                                <div className="signature">
                                                    {this.state.signature && !this.state.signPos ? <img src={this.state.signature} alt="Signature" /> : null}
                                                    {
                                                        this.state.name ? <span className="name right">{this.state.name}</span> : null
                                                    }
                                                    {this.state.signature && this.state.signPos ? <img className="right" src={this.state.signature} alt="Signature" /> : null}
                                                </div>
                                            </div>
                                        </div>
                                        {this.props.bulk ? null : <Link to="/add-message/complete-order"><RectButton text="NEXT STEP" /></Link>}
                                    </div>
                                </section>
                        }
                    </section>

                    {
                        completeOrder || this.props.bulk ?
                            <section className="section-box row">
                                <section className="custom-inserts">
                                    <TitleBar title="Custom Inserts" />
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <Select onChange={(e) => this.setState({ customInsert: parseInt(e.currentTarget.value) })}>
                                                    <Option value={0}>None</Option>
                                                    <Option value={1}>Biz Card</Option>
                                                </Select>
                                            </div>
                                            <div className="card-image">{this.state.customInsert ? <img src={this.customInserts[this.state.customInsert].src} alt={this.customInserts[this.state.customInsert].name} /> : null}</div>
                                        </div>
                                    </div>
                                </section>

                                <section className="gift-card">
                                    <TitleBar title="Add a Gift Card" />
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <Select onChange={(e) => this.setState({ giftCard: parseInt(e.currentTarget.value) })}>
                                                    <Option value={0}>None</Option>
                                                    <Option value={1}>Amazon</Option>
                                                    <Option value={2}>Cheesecake</Option>
                                                    <Option value={3}>Handwrytten</Option>
                                                    <Option value={4}>Happy Dining</Option>
                                                    <Option value={5}>Happy Moments</Option>
                                                    <Option value={6}>Homedepot</Option>
                                                    <Option value={7}>Mac Magianos</Option>
                                                    <Option value={8}>Starbucks</Option>
                                                    <Option value={9}>Target GC</Option>
                                                    <Option value={10}>Visa</Option>
                                                </Select>
                                                <Select>
                                                    <Option value={0}>None</Option>
                                                    {
                                                        this.state.giftCard ?
                                                            this.gifts[this.state.giftCard].prices.map((value, i) => {
                                                                return <Option key={`price-${i}`} value={i + 1}>${parseFloat(value).toFixed(2)}</Option>
                                                            })
                                                            : null
                                                    }
                                                </Select>
                                            </div>
                                            <div className="card-image">{this.state.giftCard ? <img src={this.gifts[this.state.giftCard].src} alt={this.gifts[this.state.giftCard].name} /> : null}</div>
                                        </div>
                                    </div>
                                </section>
                            </section>
                            : null
                    }

                    {
                        this.props.bulk ?
                            <>
                                <section className="section-box column shipping-method-options">
                                    <section className="shipping-method">
                                        <TitleBar title="Shipping Method" />
                                        <div className="box">
                                            <div className="column">
                                                <div className="row">
                                                    <Radio label="Seal, Stamp and Mailed" name="shipping-method" onChange={this.shippingChanged} />
                                                    <Radio label="Card only (no envelope)" name="shipping-method" onChange={this.shippingChanged} />
                                                    <Radio label="Written, addressed, stuffed, unsealed" name="shipping-method" onChange={this.shippingChanged} />
                                                </div>
                                                <div className="row">
                                                    <Radio label="Seal, Stamp and Ready to Mail" name="shipping-method" ref={el => (this.stampReadyMail = el)} onChange={this.shippingChanged} />
                                                    <Radio label="Cards with Blank Envelopes" name="shipping-method" onChange={this.shippingChanged} />
                                                    <Radio label="Written, addressed, stuffed, sealed" name="shipping-method" onChange={this.shippingChanged} />
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </section>

                                <section className={`section-box row shipping-stamp-options ${this.state.showShippingMethod ? "show" : ""}`}>
                                    <section className="shipping-address">
                                        <TitleBar title="Shipping Address" />
                                        <div className="box column">
                                            <div className="row lock adress">
                                                <Radio label="4206 Spruce Street, Philadelphia, PA, 19104" name="address" />
                                                <div className="actions row lock">
                                                    <EditButton onClick={() => this.context.setPopup(<EditAddressPopup edit={true} />)} />
                                                    <DeleteButton />
                                                </div>
                                            </div>
                                            <RectButton text="ADD NEW" onClick={() => this.context.setPopup(<EditAddressPopup />)} />
                                        </div>
                                    </section>
                                    <section className="shipping-options">
                                        <TitleBar title="Shipping Options" />
                                        <div className="box column">
                                            <Radio label="Ground (Free)" name="shipping-options" />
                                            <Radio label="2-Day (+4.25)" name="shipping-options" />
                                            <Radio label="Overnight (+$12.50)" name="shipping-options" />
                                        </div>
                                    </section>
                                    <section className="must-receive-by">
                                        <TitleBar title="Must Receive By" />
                                        <div className="box column">
                                            <Calendar />
                                            <p>*Larger orders require additional time. For an estimate, please contact support.</p>
                                        </div>
                                    </section>
                                </section>
                            </>
                            : null
                    }

                    {
                        completeOrder || this.props.bulk ? <Link className="add-to-basket-bt" to="/my-basket"><RectButton text="ADD TO BASKET" /></Link> : null
                    }
                </div>
            </>
        )
    }
}

export default withRouter(AddMessage);